var exports = {
  "Nr": "AccountSecurityCard.module__card___cV9FdW",
  "nL": "AccountSecurityCard.module__headerless___cV9FdW",
  "Ge": "AccountSecurityCard.module__rows___cV9FdW",
  "wx": "AccountSecurityCard.module__header___cV9FdW",
  "TK": "AccountSecurityCard.module__headerText___cV9FdW",
  "$": "AccountSecurityCard.module__titleRow___cV9FdW",
  "DD": "AccountSecurityCard.module__title___cV9FdW",
  "h_": "AccountSecurityCard.module__description___cV9FdW",
  "QE": "AccountSecurityCard.module__headerAction___cV9FdW",
  "nM": "AccountSecurityCard.module__row___cV9FdW",
  "qg": "AccountSecurityCard.module__rowText___cV9FdW",
  "xZ": "AccountSecurityCard.module__rowLabel___cV9FdW",
  "Z$": "AccountSecurityCard.module__rowDescription___cV9FdW",
  "TF": "AccountSecurityCard.module__rowWarning___cV9FdW",
  "cm": "AccountSecurityCard.module__rowActions___cV9FdW",
  "OL": "AccountSecurityCard.module__emptyRow___cV9FdW",
  "xH": "AccountSecurityCard.module__switchRow___cV9FdW",
};

module.exports = exports;
